import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { formatDate } from '../../constants/dateUtils';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import { useSelector } from 'react-redux';


const OrderTrackingSingle = () => {

    const navigate = useNavigate();
    
  const authData = useSelector(state => state.authState);
    const [orderDetail, setOrderDetail] = useState({});
    const [orderItemDetail, setOrderItemDetail] = useState({});

    const location = useLocation();
    const [processingStatus, setProcessingStatus] = useState(false);
    const [shippingStatus, setShippingStatus] = useState(false);
    const [deliveredStatus, setDeliveredStatus] = useState(false);

    const [processingTime, setProcessingTime] = useState("");
    const [shippingTime, setShippingTime] = useState("");
    const [deliveredTime, setDeliveredTime] = useState("");
    
    const [starValue, setStarValue] = useState(0);
    const [productReview, setProductReview] = useState("");
    const [reviewErrorMessage, setReviewErrorMessage] = useState({});

    const getOrderDetail = async (orderId) => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/OrderMaster/orderDetailByOrderId?orderId=${orderId}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                const ordersData = response.orderMasterDataByID;
                const orderItem = ordersData.orderItemMasters.find(item=>item.product_id === location.state.productId);

                setOrderDetail(ordersData);
                setOrderItemDetail(orderItem);
               
                if (orderItem.order_processing_done === "Done") {
                    setProcessingStatus(true);
                    const formattedDate = formatDate(orderItem.order_processing_time);
                    setProcessingTime(formattedDate);
                }
                if (orderItem.order_shipping_done === "Done") {
                    setShippingStatus(true);
                    const formattedDate = formatDate(orderItem.order_shipping_time);
                    setShippingTime(formattedDate);
                }
                if (orderItem.order_delivery_done === "Done") {
                    setDeliveredStatus(true);
                    const formattedDate = formatDate(orderItem.order_delivery_time);
                    setDeliveredTime(formattedDate);
                }

            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    useEffect(() => {
        if (location.state) {
            getOrderDetail(location.state.orderId)
        }
    }, [location.state]);

    const updateOrderStatus = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/OrderMaster/orderDetailByOrderId?orderId=${1}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                setOrderDetail(response.orderMasterDataByID)
            }
            else {
                alert(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const calculated = () => {

        if (orderDetail.created_on) {

            const specifiedDate = new Date(orderDetail.created_on);
            let currentDate = new Date();
            // currentDate.setHours(currentDate.getHours() + 6);

            const sixHoursLaterSpecifiedDate = new Date(specifiedDate.getTime() + (6 * 60 * 60 * 1000));  // Adding 6 hours
            const pendingStatus = currentDate.getTime() > sixHoursLaterSpecifiedDate.getTime()
            setProcessingStatus(pendingStatus);
            
            const formattedProcessingTime = formatDate(sixHoursLaterSpecifiedDate);
            setProcessingTime(formattedProcessingTime);

            const twelveHoursLaterSpecifiedDate = new Date(specifiedDate.getTime() + (12 * 60 * 60 * 1000)); // Adding 12 hours
            let shippingStatus = currentDate.getTime() > twelveHoursLaterSpecifiedDate.getTime();
            setShippingStatus(shippingStatus);
            const formattedShippingTime = formatDate(twelveHoursLaterSpecifiedDate);
            setShippingTime(formattedShippingTime);

            // const eighteenHoursLaterSpecifiedDate = new Date(specifiedDate.getTime() + (18 * 60 * 60 * 1000)); // Adding 18 hours
            // let DeliveredStatus = currentDate.getTime() > eighteenHoursLaterSpecifiedDate.getTime();
            // setDeliveredStatus(DeliveredStatus);
            // const formattedDeliveredTime = formatDate(twelveHoursLaterSpecifiedDate);

            // setDeliveredTime(eighteenHoursLaterSpecifiedDate);

        }

    }

    useEffect(() => {
        calculated()
    }, [orderDetail.created_on])


    const goToReturnable = (orderItemId, product_to_be_returned_by) => {
        navigate("/return", { state: { orderItemId: orderItemId, product_to_be_returned_by: product_to_be_returned_by } });
    };

      const validation = () => {
        let errorMessage = {};
    
        if (starValue === 0) {
          errorMessage.starValue = 'Please give a rating star.';
        }
    
        if (!productReview) {
          errorMessage.productReview = 'Please write your review.';
        }
    
        setReviewErrorMessage(errorMessage);
        const isValid = Object.keys(errorMessage).length === 0;
        return isValid;
      };
    
      const reviewSubmit = async () => {
        try {
    
          const isValid = await validation();
          if (!isValid) {
            return
          }
    
          let config = {
            headers: {
              'Content-Type': 'application/json', // Important for file upload//s
              'accept': 'application/json'
            }
          };
    
          let params = {
            rating_stars: starValue,
            user_id: authData.user_id,
            product_id: location.state.productId,
            product_review: productReview,
          }
    
          const response = await apiService.post(`/api/ReviewMaster/create`, params, config)
          if (response.response && response.response.data.errors) {
            alert(response.response?.data?.errors)
          }
    
          if (response.status === true) {
            alert(response.message);
            setStarValue("")
            setProductReview("")
           // getItemData(location.state.productId)
          }
          else {
            alert(response.message);
          }
        } catch (error) {
          console.log(error)
          alert('SomeThing went wrong!!');
        }
      }

    // const hanldeProductDetail = (product_id) => {
    //     navigate("/ProductDetail", { state: { productId: product_id } });
    // }

    const handleProductDetail = (selectedItem) => {     
      const url = `/product-detail/${selectedItem.product_slug}/${selectedItem.product_id}`;        
      navigate(url, { state: { productId: selectedItem.product_id } });
    };

    return (
        <>
        <section className="breadscrumb-section pt-0">
  <div className="container-fluid-lg">
    <div className="row">
      <div className="col-12">
        <div className="breadscrumb-contain">
          <h2>Order Tracking</h2>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">
                  <i className="fa-solid fa-house" />
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Order Tracking
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="order-detail py-4">
  <div className="container-fluid-lg">
    <div className="row g-sm-4 g-3">
    
      <div className="col-lg-6 d-flex gap-3 align-items-center mt-2 bg-white">
     
        <div
          className="cursor-pointer"
          onClick={() => handleProductDetail(orderItemDetail)}
        >
           
          <img
            src={`${process.env.REACT_APP_API_BASE_URL}${orderItemDetail.img_url}`}
            className="img-fluid rounded shadow-sm mb-2 mt-2"
            alt=""
            style={{ maxWidth: '150px' }}
          />
        </div>

        <div>
          <h5>{orderItemDetail.product_title}</h5>
          <div className="mt-3">
            <h4 className="fw-bold">Live Status</h4>
            {orderItemDetail.order_cancel_done === "Done" && (
                <div>
                  <h6 className='text-danger fw-bold mt-2'><i className='fa fa-circle-xmark'/> Cancelled</h6>
                  <small>{formatDate(orderItemDetail.order_cancel_time) || "N/A"}</small>
                </div>
              )}  
            <ol className="progtrckr text-wrap">
              <li className="progtrckr-done">
                <h6 className='p-2'>Received</h6>
                <small>{formatDate(orderDetail.created_on)}</small>
              </li>
              <li className={processingStatus ? "progtrckr-done" : "progtrckr-todo"}>
                <h6 className='p-2'>Processed</h6>
                <small>{processingStatus ? processingTime : "Pending"}</small>
              </li>
              <li className={shippingStatus ? "progtrckr-done" : "progtrckr-todo"}>
                <h6 className='p-2'>Shipped</h6>
                <small>{shippingStatus ? shippingTime : "Pending"}</small>
              </li>
              <li
                className={
                  orderDetail.order_delivery_done && deliveredStatus
                    ? "progtrckr-done"
                    : "progtrckr-todo"
                }
              >
                <h6 className='p-2'>Delivered</h6>
                <small>{deliveredStatus ? deliveredTime : "Pending"}</small>
              </li>
             
            </ol>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="row g-3">
          <div className="col-12">
            <div className="order-details-contain p-3 bg-light rounded shadow-sm">
              <i data-feather="package" className="text-content" />
              <div>
                <h6>Order Number</h6>
                <h5 className="theme-color">{orderDetail.order_number}</h5>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="order-details-contain p-3 bg-light rounded shadow-sm">
              <i data-feather="dollar-sign" className="text-content" />
              <div>
                <h6>Product Price / Order Total</h6>
                <h5 className="theme-color">
                  Rs {orderItemDetail.sp_after_tax} / Rs {orderDetail.grand_total}
                </h5>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="order-details-contain p-3 bg-light rounded shadow-sm">
              <i className="text-content" data-feather="info" />
              <div>
                <h6>Return </h6>
                <h5>{orderItemDetail.product_returnable === "no" && "Not Available"}</h5>
                {orderItemDetail.order_delivery_done === "Done" && orderItemDetail.product_returnable ==="yes" && 
                <h5>Available till {orderItemDetail.order_return_period_expiry_date}</h5> 
                // : <h5>Available till {orderItemDetail.product_return_in_days} days after the product is delivered</h5>
                }
                
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Review Section */}
      {!orderDetail.order_cancelled && (
        <section className="review-section">
        <div className="col-12 mt-4">
          <div className="review-title mb-3">
            <h4 className="fw-bold">Add Reviews & Ratings</h4>
          </div>
          <div className="row g-3">
            <div className="col-sm-12">
              <h6>Rate this Product</h6>
              <Box>
                <Rating
                  name="simple-controlled"
                  value={starValue}
                  onChange={(event, newValue) => setStarValue(newValue)}
                />
              </Box>
              {reviewErrorMessage.starValue && (
                <div className="text-danger">{reviewErrorMessage.starValue}</div>
              )}
            </div>

            <div className="col-sm-12">
              <div className="form-floating theme-form-floating">
                <textarea
                  className="form-control"
                  placeholder="Leave a comment here"
                  id="floatingTextarea2"
                  rows="5"
                  value={productReview}
                  onChange={(e) => setProductReview(e.target.value)}
                />
                <label htmlFor="floatingTextarea2">Write Your Review</label>
              </div>
              {reviewErrorMessage.productReview && (
                <div className="text-danger">{reviewErrorMessage.productReview}</div>
              )}
            </div>

            <div className="col-sm-12 text-end p-2">
              <button
                type="button"
                onClick={() => reviewSubmit()}
                className="btn theme-bg-color text-light"
              >
                Submit Review
              </button>
            </div>
          </div>
        </div>
        </section>
      )}
    </div>
  </div>
</section>

         
        </>

    )
}

export default OrderTrackingSingle;